<template>
  <RadioInputList
    :id="$attrs.id || 'AutoModelYearRadioList'"
    :key="$attrs.key || 'AutoModelYearRadioList'"
    v-bind="$attrs"
    :title="$attrs.title || 'Selecione o ano do modelo do veículo'"
    :options="$attrs.options || cptdModelYearList"
    :searchable="false"
    @input="$emit('input', $event)"
  />
</template>
<script>
import { generateYearListFrom } from '@/helpers/date'
import RadioInputList from '@/components/ui/newComponents/RadioInputList.vue'
export default {
  name: 'AutoModelYearRadioList',
  components: {
    RadioInputList,
  },
  inheritAttrs: false,
  props: {
    minYear: {
      type: [Number, String],
      default: Number(
        import.meta.env.VITE_AUTO_EQUITY_MIN_AUTO_MODEL_YEAR_LIST,
      ),
    },
  },
  emits: ['input'],
  computed: {
    cptdModelYearList() {
      return generateYearListFrom(this.minYear).map((y) => ({
        label: y,
        id: y,
        value: y,
      }))
    },
  },
}
</script>
<style lang="scss"></style>
